import { render, staticRenderFns } from "./DialogVoltarEtapas.vue?vue&type=template&id=071e8051&"
import script from "./DialogVoltarEtapas.vue?vue&type=script&lang=js&"
export * from "./DialogVoltarEtapas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports